var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseDoor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.469 0.718998C9.53867 0.649153 9.62143 0.593739 9.71255 0.555929C9.80367 0.518119 9.90135 0.498657 10 0.498657C10.0987 0.498657 10.1963 0.518119 10.2875 0.555929C10.3786 0.593739 10.4613 0.649153 10.531 0.718998L19.531 9.719C19.6006 9.78878 19.6558 9.87159 19.6933 9.9627C19.7309 10.0538 19.7502 10.1514 19.75 10.25V20.75C19.75 20.9489 19.671 21.1397 19.5303 21.2803C19.3897 21.421 19.1989 21.5 19 21.5H12.25C12.0511 21.5 11.8603 21.421 11.7197 21.2803C11.579 21.1397 11.5 20.9489 11.5 20.75V14.75H8.5V20.75C8.5 20.9489 8.42098 21.1397 8.28033 21.2803C8.13968 21.421 7.94891 21.5 7.75 21.5H1C0.801089 21.5 0.610323 21.421 0.469671 21.2803C0.329019 21.1397 0.250001 20.9489 0.250001 20.75V10.25C0.249825 10.1514 0.269076 10.0538 0.306654 9.9627C0.344231 9.87159 0.399399 9.78878 0.469001 9.719L9.469 0.718998ZM1.75 10.5605V20H7V14C7 13.8011 7.07902 13.6103 7.21967 13.4697C7.36032 13.329 7.55109 13.25 7.75 13.25H12.25C12.4489 13.25 12.6397 13.329 12.7803 13.4697C12.921 13.6103 13 13.8011 13 14V20H18.25V10.5605L10 2.3105L1.75 10.5605Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseDoor);
export default __webpack_public_path__ + "static/media/House-door.c56b81ec391bf0103f20f8e55e8c442f.svg";
export { ForwardRef as ReactComponent };